import React, { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { YMaps, Map, Placemark } from '@pbe/react-yandex-maps';
import { Modal } from 'react-bootstrap'
import { httpOk, POST } from 'helpers/api';
import { getYandexSearchBounds } from 'helpers/helpers'
import { posPlacemarkOptions, posPlacemarkProperties } from 'helpers/mapPlacemark';
import { yandexReverseGeocode } from 'helpers/yandexGeocoder'
import AddressSuggestField from 'pages/parts/AddressSuggestField'

const MAP_KEY = 'b5de12cc-6217-4b13-9078-2e99c84df330'

function Index({ modalMap, newAddress, setNewAddress, toggleModalMap, createClientAddress }) {
	const { t } = useTranslation()

	const reduxDelivery = useSelector(state => state.delivery)

	const mapRef = useRef(null)

	const [defaultState, setDefaultState] = useState({
		center: [41.311081, 69.240562],
		zoom: 13,
		controls: ["zoomControl"]
	});
	const mapSearchBounds = getYandexSearchBounds(reduxDelivery?.poses || [])

	async function findClosestPos(obj = { 'latitude': '', 'longitude': '', 'full_address': '', 'short_address': '' }) {
		const address = obj.address || obj.full_address || ''

		const response = await POST('/delivery/closest-pos', {
			"latitude": obj.latitude,
			"longitude": obj.longitude,
			"address": address,
		}, { loader: true })

		if (httpOk(response)) {
			setNewAddress((prev) => ({
				...prev,
				'latitude': obj.latitude,
				'longitude': obj.longitude,
				'new_address': address,
				'address': address,
				'full_address': obj.full_address ?? "",
				'short_address': obj.short_address ?? "",
				'pos_id': response.data.id,
				'pos_name': response.data.name,
				'distance': response.data.distance,
			}))
		}
	}

	// Клик по карте. Метку ставим сразу: она не должна зависеть от геокодера. Если геокодер
	// недоступен (исчерпан лимит) — вместо адреса координаты, расчёт ближайшего pos всё равно отрабатывает.
	async function pickPoint(latitude, longitude) {
		setNewAddress((prev) => ({ ...prev, 'latitude': latitude, 'longitude': longitude }));

		const coordsText = `${latitude.toFixed(6)}, ${longitude.toFixed(6)}`
		let found = null
		try {
			found = await yandexReverseGeocode(MAP_KEY, latitude, longitude)
		} catch (e) {
			// геокодер недоступен — остаются координаты
		}

		pickAddress({
			'latitude': latitude,
			'longitude': longitude,
			'full_address': found?.full_address || coordsText,
			'short_address': found?.short_address || coordsText,
		}, false)
	}

	// Адрес выбран (кликом или из поиска): метка, ближайший pos, а для найденного поиском — центр карты
	function pickAddress(picked, center = true) {
		setNewAddress((prev) => ({ ...prev, 'latitude': picked.latitude, 'longitude': picked.longitude }));
		findClosestPos({ ...picked, 'address': picked.full_address });
		if (center && typeof mapRef.current?.setCenter === 'function') {
			mapRef.current.setCenter([picked.latitude, picked.longitude], 17)
		}
	}

	useEffect(() => {
		if (reduxDelivery?.poses.length > 0 && reduxDelivery?.poses[0]['longitude']) {
			setDefaultState({
				center: [reduxDelivery?.poses[0]['latitude'], reduxDelivery?.poses[0]['longitude']],
				zoom: 13,
				controls: ["zoomControl"]
			})
		}
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<Modal
				show={modalMap}
				animation={false}
				dialogClassName="custom-delivery-modal"
				onHide={() => toggleModalMap()}>
				<Modal.Body>
					<div className="row">
						<div className="col-md-12 position-relative" style={{ height: '80vh' }}>
							{/* Поиск адреса поверх карты. SearchControl из JS API ищет через сервис, который
								не принимает ключи нового кабинета Яндекса, поэтому — своё поле на HTTP-геокодере */}
							<AddressSuggestField
								className="map-address-search"
								mapToken={MAP_KEY}
								boundedBy={mapSearchBounds}
								placeholder={t('search_address')}
								onPick={(picked) => pickAddress(picked)} />
							<YMaps
								style={{ height: '80vh' }}
								query={{
									load: "package.full",
									apikey: MAP_KEY
								}}>
								<Map
									instanceRef={(mapInstance) => { mapRef.current = mapInstance; }}
									style={{ height: '80vh' }}
									defaultOptions={{
										copyrightUaVisible: false,
										yandexMapDisablePoiInteractivity: true,
									}}
									defaultState={defaultState}
									onClick={(event) => {
										const coords = event.get("coords");
										pickPoint(Number(coords[0]), Number(coords[1]));
									}}>
									{newAddress?.latitude &&
										<Placemark geometry={[newAddress.latitude, newAddress.longitude]} />
									}
									{reduxDelivery?.poses.map((item, index) => (
										<Placemark
											key={index}
											options={posPlacemarkOptions}
											properties={posPlacemarkProperties({
												name: item.name,
												phone: item.phone,
												t: t,
											})}
											geometry={[Number(item.latitude), Number(item.longitude)]} />
									))}
								</Map>
							</YMaps>
						</div>
					</div>
					<div className="d-flex w-100 mt-3">
						<button type="button" className="btn btn-outline-warning w-100 me-2" style={{ 'flex': 1 }}
							onClick={() => toggleModalMap()}>
							{t('cancel')}
						</button>
						<button type="submit" className="btn btn-primary w-100" style={{ 'flex': 3 }}
							onClick={() => createClientAddress()}>
							<span>{t('save')}</span>
						</button>
					</div>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default Index
